import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Upload,
} from "antd";
import { useCallback } from "react";
import { useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation, useNavigate } from "react-router";
import SendMoneyService from "../../services/send-money.service";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  accountListSelector,
  modeSelector,
  selectedAccountSelector,
} from "../../store/selectors/app.selector";
import TransferService from "../../services/transfer.service";
import { GoPlusSmall } from "react-icons/go";
import { HiOutlineMinusSmall } from "react-icons/hi2";
import {
  allowDecimalwithMaxLimit,
  allowOnlyAlphaNumerics,
  allowOnlyAlphaNumericsWithSpace,
  allowOnlyNumbers,
  allowOnlyAlphaNumericsShouldNotStartWithSpace,
  amountExchangeCurrencyFormat,
  amountFormat,
} from "../../services/common.service";
import CommonOtp from "../../components/otp";
import successIcon from "../../assests/images/success.png";
import { UploadOutlined } from "@ant-design/icons";
import {
  setAccountList,
  setSelectedAccount,
} from "../../store/actions/app.action";
import AccountService from "../../services/accounts.service";
import dayjs from "dayjs";
import AccountDisplay from "../../components/account-display";
import BeneficiaryDisplay from "../../components/beneficiary-display";
import { CONFIG } from "../../environment";
import { AiOutlineLeft } from "react-icons/ai";
import AccountDisplayView from "../../components/account-display-view";
import { ReactComponent as TitleIcon } from "../../assests/images/transfer.svg";
import AccountCard from "../../components/account-card";
import AccountSelectedCard from "../../components/account-selected-card";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import { FiUpload } from "react-icons/fi";
import Dragger from "antd/es/upload/Dragger";
import PendingAuthService from "../../services/approvals.service";
import { VscError } from "react-icons/vsc";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function PayeeTransfer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formDetails, setFormDetails] = useState({});
  const [reqDetails, setReqDetails] = useState({
    transferType: "IAT",
  });
  const { t } = useTranslation();
  const [stage, setStage] = useState(1);
  const accountList = useSelector(accountListSelector);
  const location = useLocation();
  const [form] = Form.useForm();
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [paymentType, setPaymentType] = useState("ONCE");
  const [paymentSubType, setPaymentSubType] = useState("Pay_Now");
  const [verifyDetails, setVerifyDetails] = useState({});
  const [visible, setVisible] = useState(false);
  const [transferType, setTransferType] = useState("IAT");
  const [cancelVisible, setCancelVisible] = useState(false);
  const [respDetails, setRespDetails] = useState({});
  const [remarksDetail, setRemarkDetail] = useState("");
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [metaData, setMetaData] = useState({
    frequency: [],
    maximumInstallments: [],
    paymentTypes: {},
    transferTypes: {},
    tipsMaxAmount: 1,
  });
  const [payeeDetails, setPayeeDetails] = useState({});
  const mode = useSelector(modeSelector);
  const selectedAccount = useSelector(selectedAccountSelector);
  const [hasFxDeal, setHasFxDeal] = useState(false);
  const [remarksList, setRemarksList] = useState([]);
  const [convertedAmount, setConvertedAmount] = useState({});
  const [selectedRemarks, setSelectedRemarks] = useState();
  const [selectedTxnCcy, setSelectedTxnCcy] = useState();
  const [txnCurrencyList, setTxnCurrencyList] = useState([]);
  const [otp, setOtp] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [uploadFile, setUploadFile] = useState("");
  const [allFiles, setAllFiles] = useState([]);
  const [modifyVisible, setModifyVisible] = useState(false);
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const [chargesList, setChargesList] = useState([]);

  useEffect(() => {
    transferOptions();
    getRemarks();
    if (location.state) {
      if (location.state.mode === "PAY_LIST") {
        form.setFieldsValue({
          transferType:
            location.state.beneType === "OTHERBANK"
              ? "TISS"
              : location.state.beneType,
          paymentType: "ONCE",
          paymentSubType: "Pay_Now",
          hasFxDeal: false,
        });
        setPayeeDetails({
          bankBranch: location.state?.beneBrn || "",
          beneName: location.state?.beneName || "",
          payeeAccountNo: location.state?.beneAccNo,
          bankName: location.state?.bankName,
          payeeId: location.state?.reqId,
          payeeNickName: location.state?.beneNickName,
          beneEmail: location.state?.beneEmail,
          beneMobileNo: location.state?.beneMobileNo,
          customFields:
            Object.keys(location.state.customFields || {}).length === 0
              ? {}
              : typeof location.state.customFields === "string"
              ? JSON.parse(location.state.customFields)
              : location.state.customFields,
          beneCurrency: location.state?.beneCurrency,
          bicCode: location.state?.bicCode,
          sortCode: location.state?.sortCode,
          beneAddress: location.state?.beneAddress,
          swiftCode: location.state?.swiftCode,
        });
        setTransferType(
          location.state.beneType === "INTERNAL"
            ? "IAT"
            : location.state.beneType === "OTHERBANK"
            ? "TISS"
            : location.state.beneType === "INTERNATIONAL"
            ? "SWIFT"
            : location.state.beneType
        );
      }
      if (location.state.mode === "PAY_AGAIN") {
        form.setFieldsValue({
          transferType:
            location.state.transferType === "OTHERBANK"
              ? "RTGS"
              : location.state.transferType,
          paymentType: location.state.paymentType,
          paymentSubType: "Pay_Now",
          hasFxDeal: location.state.fxDealRefNo === "" ? false : true,
          amount: location.state.amount,
          txnCcy: location.state.txnCcy,
        });
        if (location.state.txnCcy !== location.state.srcCcy) {
          getConvertedAmount();
        }
        setPayeeDetails({
          beneName: location.state?.destAccName || "",
          payeeAccountNo: location.state?.destAccount,
          bankName: location.state?.destBankName,
          beneCurrency: location.state?.destCcy,
          bankBranch: location.state?.destAccBranch || "",
          payeeId: location.state?.payeeId,
          payeeNickName: location.state?.beneNickName || "",
          beneEmail: location.state?.beneEmail || "",
          beneMobileNo: location.state?.beneMobileNo || "",
          customFields:
            Object.keys(location.state.customFields || {}).length === 0
              ? {}
              : typeof location.state.customFields === "string"
              ? JSON.parse(location.state.customFields)
              : location.state.customFields,

          bicCode: location.state?.bicCode,
          sortCode: location.state?.sortCode,
          beneAddress: location.state?.beneAddress || "",
          swiftCode: location.state?.swiftCode || "",
          beneCountry: location.state?.beneCountry || "",
          bankCountry: location.state?.bankCountry || "",
          beneType: location.state.beneType || "",
        });
        getRemarks(location.state.beneType);
        setTransferType(location.state.transferType);
      }
    }
  }, []);

  useEffect(() => {
    if (accountList?.length > 0) {
      setConvertedAmount({});
      if (location.state && location.state.amount === undefined) {
        form.resetFields(["amount"]);
      }
      if (transferType === "IAT" || transferType === "ABC") {
        if (Object.keys(payeeDetails).length > 0) {
          if (CONFIG?.CROSS_CURRENCY === false) {
            setTxnCurrencyList([selectedAccount?.accountCurrency]);
          } else if (
            payeeDetails?.beneCurrency === selectedAccount?.accountCurrency
          ) {
            setTxnCurrencyList([selectedAccount?.accountCurrency]);
          } else {
            setTxnCurrencyList([
              payeeDetails?.beneCurrency,
              selectedAccount?.accountCurrency,
            ]);
          }
        } else {
          setTxnCurrencyList([selectedAccount?.accountCurrency]);
        }
        form.setFieldsValue({ txnCcy: selectedAccount?.accountCurrency });
      } else if (transferType === "TISS") {
        // if (selectedAccount?.accountCurrency !== CONFIG.CURRENCY) {
        //   setTxnCurrencyList(CONFIG.CURRENCY_LIST);
        // } else {
        //   setTxnCurrencyList([CONFIG.CURRENCY]);
        // }
        getTxnCurrency();

        // form.setFieldsValue({ txnCcy: CONFIG.CURRENCY });
      } else if (transferType === "EFT" || transferType === "TIPS") {
        setTxnCurrencyList([CONFIG.CURRENCY]);
        form.setFieldsValue({ txnCcy: CONFIG.CURRENCY });
      } else if (transferType === "SWIFT") {
        if (Object.keys(payeeDetails).length > 0) {
          if (payeeDetails?.beneCurrency === selectedAccount?.accountCurrency) {
            setTxnCurrencyList([selectedAccount?.accountCurrency]);
          } else {
            setTxnCurrencyList([
              payeeDetails?.beneCurrency,
              selectedAccount?.accountCurrency,
            ]);
          }
        } else {
          setTxnCurrencyList([selectedAccount?.accountCurrency]);
        }
        form.setFieldsValue({ txnCcy: selectedAccount?.accountCurrency });
      } else {
        setTxnCurrencyList([]);
        form.setFieldsValue({ txnCcy: "" });
      }
    }
  }, [accountList, selectedAccount, transferType, payeeDetails]);

  const getTxnCurrency = useCallback(async () => {
    try {
      const reqParams = {
        transferType: "TISS",
      };
      const response = await TransferService.getTxnCurrency(reqParams);
      if (response.status === 200) {
        const currencies = response.data["data"].map((ele) => ele.currencyCode);
        setTxnCurrencyList(currencies);
        form.setFieldsValue({ txnCcy: CONFIG?.CURRENCY });
      }
    } catch (error) {}
  }, []);

  const onChange = useCallback(
    (info) => {
      if (info.file.status === "done") {
        console.log(" metaData?.internationalFileUploadSize", metaData);
        const fileSize =
          parseFloat(
            (metaData?.internationalFileUploadSize).replace(/[^0-9.]/g, "")
          ) *
          1024 *
          1024;

        if (info.file.size <= fileSize) {
          const uploadedFiles = info.fileList.map((file) => file.originFileObj);
          setUploadFile(uploadedFiles);
        } else {
          setIsErrorModalVisible(true);
        }
      }
    },
    [metaData]
  );

  const onRemove = useCallback(() => {
    setUploadFile("");
  });

  const handleAction = useCallback(({ file, onSuccess }) => {
    console.log(file);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  });

  const getRemarks = useCallback(async () => {
    try {
      const response = await TransferService.getRemarks();
      if (response.status === 200) {
        setRemarksList(response.data["data"]);
      }
    } catch (error) {}
  }, []);

  const transferOptions = useCallback(async () => {
    try {
      const response = await SendMoneyService.transferOptions();
      if (response.status === 200) {
        setMetaData(response.data["data"]);
      }
    } catch (error) {}
  }, []);

  const getConvertedAmount = useCallback(async () => {
    try {
      if (CONFIG?.CROSS_CURRENCY === false) {
        return;
      }
      const { amount, txnCcy, fxDealRefNo } = form.getFieldsValue();
      setSelectedTxnCcy(txnCcy);
      const transferAmount =
        typeof amount === "number"
          ? amount
          : parseFloat(amount.replaceAll(/,/g, ""));
      const reqParams = {
        srcCcy: selectedAccount?.accountCurrency,
        destCcy: txnCcy, // payeeDetails?.beneCurrency || CONFIG.CURRENCY,
        txnCcy: txnCcy,
        txnType: transferType,
        amount: transferAmount,
        fxDealRefNo: fxDealRefNo,
        srcAcct: selectedAccount?.accountNo,
        accountName: selectedAccount?.accountName,
        srcAccName: selectedAccount?.accountName,
      };

      if (txnCcy === selectedAccount?.accountCurrency) {
        return;
      }
      const response = await TransferService.getConvertedAmount(reqParams);
      if (response.status === 200) {
        setConvertedAmount(response.data["data"]);
      }
    } catch (error) {}
  }, [selectedAccount, payeeDetails, transferType]);

  const getSrcAccDetails = useCallback(() => {
    return accountList.find(
      (ele) => ele.accountNo === selectedAccount.accountNo
    );
  }, [accountList, selectedAccount]);

  const getTransferAmount = (amount) => {
    return typeof amount === "number"
      ? amount
      : parseFloat(amount.replaceAll(/,/g, ""));
  };

  const buildReqParams = useCallback(
    (values, allFiles) => {
      const srcAccDetails = getSrcAccDetails();
      const transferAmount = getTransferAmount(values.amount);
      const fxdealrates = values?.fxDealRefNo
        ? {
            fxreferencerate: convertedAmount?.convRate || "",
            isfxDealRateAvl: "Y",
          }
        : { fxreferencerate: "", isfxDealRateAvl: "N" };

      let txnType = "";

      if (CONFIG?.CROSS_CURRENCY === false) {
        if (srcAccDetails?.accountCurrency !== payeeDetails?.beneCurrency) {
          setIsErrorVisible(true);
          return;
        }
      }

      if (transferType === "TISS") {
        if (srcAccDetails?.accountCurrency !== CONFIG.CURRENCY) {
          txnType = "TISS";
        } else if (values?.txnCcy === srcAccDetails?.accountCurrency) {
          txnType = transferAmount <= metaData?.tipsMaxAmount ? "TIPS" : "TISS";
        } else {
          txnType = "TISS";
        }
      } else {
        txnType = transferType;
      }

      return {
        srcAcct: srcAccDetails?.accountNo,
        accountName: srcAccDetails?.accountName,
        srcAccName: srcAccDetails?.accountName,
        srcBr: srcAccDetails?.branchId,
        srcCcy: srcAccDetails?.accountCurrency,
        destBr: payeeDetails?.beneBrn || payeeDetails?.bankBranch,
        destCcy:
          transferType === "IAT"
            ? payeeDetails?.beneCurrency || CONFIG.CURRENCY
            : CONFIG.CURRENCY,
        destAcct: payeeDetails?.payeeAccountNo,
        amount: transferAmount,
        narration: values?.remarks || "",
        remarks: values?.remarks || "",
        remarksTag: values?.remarks,
        txnType: txnType,
        quickTransfer: false,
        destBankName: payeeDetails?.bankName,
        destBankAddr: "",
        destBankCty: "",
        txnCcy: values?.txnCcy,
        txnDate: dayjs(new Date()),
        chargeBornesBy: "OUR",
        beneName: payeeDetails?.beneName || "",
        beneMobileNo: payeeDetails?.beneMobileNo || "",
        beneMail: payeeDetails?.beneEmail || "",
        beneAddr: payeeDetails?.beneAddress || "",
        fxDealRefNo: values?.fxDealRefNo || "",
        bicCode: payeeDetails?.bicCode || "",
        sortCode: payeeDetails?.sortCode || "",
        swiftCode: payeeDetails?.swiftCode || "",
        custId: srcAccDetails?.customerId,
        paymentType:
          paymentType === "ONCE" && paymentSubType === "Pay_Later"
            ? "SCHEDULED"
            : paymentType,
        numberOfInstallments: values?.numberOfInstallment,
        customFields: { ...payeeDetails?.customFields, ...fxdealrates },
        payeeId: payeeDetails?.payeeId,
        bulkTransfer: false,
        scheduled:
          paymentType === "ONCE" && paymentSubType === "Pay_Later"
            ? true
            : false,
        addBene: false,
        recurring: paymentType === "RECURRING",
        scheduledDate: values?.frequencyDate
            ? values?.frequencyDate.format("YYYY-MM-DD")
            : "",
        frequency: values?.frequency,
        ...(transferType === "SWIFT" && {
          addressLine1: "",
          addressLine2: "",
          city: "",
          beneCountry: payeeDetails?.beneCountry || "",
          bankCountry: payeeDetails?.bankCountry || "",
          fileNames: allFiles.length > 0 ? allFiles : "",
        }),
      };
    },
    [
      payeeDetails,
      allFiles,
      selectedAccount,
      paymentType,
      paymentSubType,
      transferType,
      accountList,
      convertedAmount,
      metaData,
      CONFIG,
    ]
  );

  const onVerify = useCallback(
    async (values) => {
      try {
        if (modifyVisible === false && transferType === "SWIFT") {
          const srcAccDetails = accountList.find(
            (ele) => ele.accountNo === selectedAccount.accountNo
          );
          const req = {
            files: uploadFile,
            srcAcct: srcAccDetails.accountNo,
            accountName: srcAccDetails?.accountName,
            srcAccName: srcAccDetails?.accountName,
          };
          const response = await TransferService.internationalfileUpload(req);
          if (response.status === 200) {
            setAllFiles(response.data["data"]["fileNames"]);

            setReqDetails(values);
            const reqParams = buildReqParams(
              values,
              response.data["data"]["fileNames"]
            );
            setFormDetails(reqParams);
            console.log(values);
            getCharges(reqParams);
            // fundTransferVerify(reqParams);
            //setStage(2);
          }
        } else {
          setReqDetails(values);
          const reqParams = buildReqParams(values, {});
          setFormDetails(reqParams);
          console.log(values);
          getCharges(reqParams);
          // fundTransferVerify(reqParams);
          //setStage(2);
        }
      } catch (error) {}
    },
    [
      transferType,
      uploadFile,
      accountList,
      allFiles,
      payeeDetails,
      selectedAccount,
      paymentSubType,
      paymentType,
      modifyVisible,
      metaData,
      convertedAmount,
    ]
  );

  const fundTransferVerify = useCallback(
    async (data) => {
      try {
        const req = {
          ...data,
          conversionAmount: convertedAmount?.convAmt || "",
          conversionRate: convertedAmount.convRate || "",
          charges: chargesList.charges || "",
        };
        setFormDetails(req);
        const response = await TransferService.fundTransferVerify(req);
        if (response.status === 200) {
          setVerifyDetails(response.data["data"]);

          if (response.data["data"]["otpEnabled"]) {
            setStage(3);
          } else {
            fundTransferConfirm({
              ...req,
              ...{ otp: CONFIG.DEFAULT_OTP },
            });
          }
        }
      } catch (error) {}
    },
    [formDetails, convertedAmount, chargesList]
  );

  const fundTransferConfirm = useCallback(async (reqParams) => {
    try {
      const response = await TransferService.fundTransferConfirm(reqParams);
      if (response.status === 200) {
        dispatch(setAccountList([]));
        setRespDetails({
          message: response.data?.message,
          ...response.data["data"],
        });
        setSuccessVisible(true);
        await AccountService.getQuickAccounts("BA");
      }
    } catch (error) {
      setOtp("");
      if (["TG-USR-40025", "TG-USR-40026"].indexOf(error.data.code) < 0) {
        setStage(1);
      }
    }
  }, []);

  const handleDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        txnId: selected?.txnId,
      };
      setSuccessVisible(false);

      await PendingAuthService.downloadReceipts(reqParams);
      navigate("/transfer");
    } catch (err) {}
  }, []);

  const handleResendOtp = useCallback(async (data) => {
    try {
      const req = {
        ...data,
      };
      const response = await TransferService.fundTransferVerify(req);
      if (response.status === 200) {
      }
    } catch (error) {}
  }, []);

  const getCharges = useCallback(
    async (data) => {
      try {
        const req = {
          srcAcct: data.srcAcct,
          srcCcy: data.srcCcy,
          destCcy: data.destCcy,
          txnCcy: data.txnCcy,
          amount: data.amount,
          txnType: data.txnType,
        };
        const response = await AccountService.getAllCharges(req);
        if (response.status === 200) {
          setChargesList(response.data);
          setStage(2);
        }
      } catch (error) {}
    },
    []
  );
  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) =>
              fundTransferConfirm({
                ...formDetails,
                ...values,
              })
            }
            handleResendOtp={() => handleResendOtp(formDetails)}
            cancelTransaction={() => {
              navigate("/transfer");
              setVerifyDetails({});
            }}
          />
        );

      case 4:
        return renderSuccess();
      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row">
          <div className="bene-align">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
              {transferType === "TIPS" ? (
                <AccountDisplay type="image" currencyFilter={true} />
              ) : (
                <AccountDisplay type="image" />
              )}
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center">
              <p style={{ fontSize: 10, fontWeight: 600 }}>
                {t("common.to", { defaultValue: "To" })}
              </p>
            </div>
            <div
              className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
              style={{ marginTop: "-19px" }}
            >
              <BeneficiaryDisplay beneDetails={payeeDetails} />
            </div>
          </div>
        </div>

        <Form
          layout="vertical"
          onFinish={onVerify}
          requiredMark={true}
          initialValues={reqDetails}
          form={form}
        >
          <div className="row">
            <div className="col-xs-12 col-xl-7 col-sm-12 col-md-6 col-lg-7">
              {location.state.beneType === "OTHERBANK" && (
                <Form.Item
                  label={t("pages.payment_history.transfer_type", {
                    defaultValue: "Transfer Type",
                  })}
                  name={"transferType"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.transfer_type_require", {
                        defaultValue: "Transfer Type is required",
                      }),
                    },
                  ]}
                >
                  <Radio.Group
                    onChange={(e) => setTransferType(e.target.value)}
                  >
                    {/* <Radio value={"TISS"}>
                      {t("pages.sendMoney.common_sendMoney.tiss", {
                        defaultValue: "TISS",
                      })}
                    </Radio> */}
                    <Radio value={"EFT"}>
                      {t("pages.sendMoney.common_sendMoney.eft", {
                        defaultValue: "EFT",
                      })}
                    </Radio>
                    <Radio value={"RTGS"}>RTGS</Radio>
                  </Radio.Group>
                </Form.Item>
              )}
            </div>
            <div
              className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
              style={{ position: "relative" }}
            >
              {" "}
              <Form.Item
                label={t("pages.fundtransfer.transaction_curr", {
                  defaultValue: "Transaction Currency",
                })}
                name={"txnCcy"}
                rules={[
                  {
                    required: txnCurrencyList.length <= 1 ? false : true,
                    message: t("errorMesssages.trans_currency_require", {
                      defaultValue: "Transaction Currency is required",
                    }),
                  },
                ]}
              >
                {txnCurrencyList.length <= 1 ? (
                  <Input readOnly size="large" />
                ) : (
                  <Select
                    placeholder={t("pages.fundtransfer.transaction_curr", {
                      defaultValue: "Transaction Currency",
                    })}
                    bordered={true}
                    size="large"
                    optionFilterProp="children"
                    showSearch
                    onChange={(e) => {
                      form.setFieldsValue({ amount: "" });
                      setConvertedAmount({});
                    }}
                  >
                    {txnCurrencyList.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <Form.Item
                label={t("common.amount", {
                  defaultValue: "Amount",
                })}
                name={"amount"}
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.amount_required", {
                      defaultValue: "Amount is required",
                    }),
                  },
                  {
                    validator: (_, value) => {
                      if (parseFloat(value) <= 0) {
                        return Promise.reject(
                          t("errorMesssages.amount_valid", {
                            defaultValue: "Amount should be greater than 0",
                          })
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <NumericFormat
                  type="tel"
                  placeholder={t("common.amount", {
                    defaultValue: "Amount",
                  })}
                  maxLength={12}
                  allowNegative={false}
                  customInput={Input}
                  thousandSeparator={true}
                  fixedDecimalScale={false}
                  onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                  onBlur={(e) => {
                    e.target.value.length > 0 && getConvertedAmount();
                  }}
                  size="large"
                  onChange={() => setConvertedAmount({})}
                />
              </Form.Item>
              {Object.keys(convertedAmount).length !== 0 && (
                <div className="row mb-2">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <label className="mb-1">
                      {convertedAmount?.prefferedRate === true
                        ? t("pages.sendMoney.common_sendMoney.preffered_rate", {
                            defaultValue: "Preffered Rate",
                          })
                        : t("pages.sendMoney.common_sendMoney.exchange_rate", {
                            defaultValue: "Exchange Rate",
                          })}
                    </label>{" "}
                    <br />
                    <span>
                      1 {selectedAccount?.accountCurrency} ={" "}
                      {selectedTxnCcy + " " + convertedAmount.convRate}
                    </span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <label className="mb-1">
                      {" "}
                      {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                        defaultValue: "Deducted Amount",
                      })}
                    </label>
                    <br />
                    <span>{convertedAmount.deductedAmt}</span>
                  </div>
                </div>
              )}
            </div>
            <span
              className="d-block mb-3 "
              style={{ textAlign: "left", cursor: "pointer" }}
            >
              {/* {showAdvanced && (
                <>
                  <HiOutlineMinusSmall />
                  {t("pages.fundtransfer.payment_options", {
                    defaultValue: "Payment Options",
                  })}
                </>
              )} */}

              {t("pages.fundtransfer.payment_options", {
                defaultValue: "Payment Options",
              })}
            </span>

            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
                <Form.Item
                  label=""
                  name={"paymentType"}
                  style={
                    paymentType === "RECURRING"
                      ? { marginBottom: 20 }
                      : { marginBottom: 5 }
                  }
                >
                  <Radio.Group onChange={(e) => setPaymentType(e.target.value)}>
                    <Radio value={"ONCE"}>
                      {t("pages.fundtransfer.one_time", {
                        defaultValue: "One Time",
                      })}
                    </Radio>
                    <Radio value={"RECURRING"}>
                      {t("pages.fundtransfer.recurring", {
                        defaultValue: "Recurring",
                      })}
                    </Radio>
                  </Radio.Group>
                </Form.Item>
                {paymentType === "ONCE" && (
                  <Form.Item label="" name={"paymentSubType"}>
                    <Radio.Group
                      onChange={(e) => setPaymentSubType(e.target.value)}
                    >
                      <Radio value={"Pay_Now"}>
                        {t("pages.fundtransfer.pay_now", {
                          defaultValue: "Pay Now",
                        })}
                      </Radio>
                      <Radio value={"Pay_Later"}>
                        {t("pages.fundtransfer.pay_later", {
                          defaultValue: "Pay Later",
                        })}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
              </div>
            </div>

            {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.sendMoney.common_sendMoney.date", {
                    defaultValue: "Date",
                  })}
                  name={"frequencyDate"}
                  style={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.date_require", {
                        defaultValue: "Date is required",
                      }),
                    },
                  ]}
                >
                  <DatePicker
                    // inputReadOnly={true}
                    allowClear={false}
                    showToday={false}
                    disabledDate={(current) => {
                      return (
                        dayjs().add(0, "days") >= current ||
                        dayjs().add(1, "month") <= current
                      );
                    }}
                    placeholder="DD-MM-YYYY"
                    // format={"DD-MM-YYYY"}
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}

            {paymentType === "RECURRING" && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Form.Item
                  label={t("pages.fundtransfer.no_of_instal", {
                    defaultValue: "Number of installment",
                  })}
                  name={"numberOfInstallment"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.no_insdtall_require", {
                        defaultValue: "Number of installment is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("pages.fundtransfer.no_of_instal", {
                      defaultValue: "Number of installment",
                    })}
                    bordered={true}
                    size="large"
                  >
                    {metaData.maximumInstallments.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {paymentType === "RECURRING" && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Form.Item
                  label={t("pages.fundtransfer.frequency", {
                    defaultValue: "Frequency",
                  })}
                  name={"frequency"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.freq_requir", {
                        defaultValue: "Frequency is required",
                      }),
                    },
                  ]}
                >
                  <Select
                    placeholder={t("pages.fundtransfer.frequency", {
                      defaultValue: "Frequency",
                    })}
                    bordered={true}
                    size="large"
                  >
                    {metaData.frequency.map((option, idx) => (
                      <Select.Option key={idx} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            )}

            {paymentType === "RECURRING" && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <Form.Item
                  label={t("pages.common.start_date", {
                    defaultValue: "Start Date",
                  })}
                  name={"frequencyDate"}
                  style={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.start_date_require", {
                        defaultValue: "Start Date is required",
                      }),
                    },
                  ]}
                >
                  <DatePicker
                    // inputReadOnly={true}
                    allowClear={false}
                    showNow={false}
                    disabledDate={(current) => {
                      return (
                        dayjs().add(0, "days") >= current ||
                        dayjs().add(1, "month") <= current
                      );
                    }}
                    placeholder="DD-MM-YYYY"
                    // format={"DD-MM-YYYY"}
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    size="large"
                  />
                </Form.Item>
              </div>
            )}
            {/* {form?.getFieldValue("txnCcy") !==
              selectedAccount?.accountCurrency && (
              <Form.Item
                label={""}
                name="hasFxDeal"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.has_fx_deal_require", {
                      defaultValue: "Has Fx Deal is required",
                    }),
                  },
                ]}
              >
                <span style={{ marginRight: "10px" }}>
                  <span className="asterisk-mark">*</span>
                  {t("pages.fundtransfer.hasfx", {
                    defaultValue: "Has Fx Deal ?",
                  })}
                </span>
                <Radio.Group
                  onChange={(e) => setHasFxDeal(e.target.value)}
                  value={hasFxDeal}
                >
                  <Radio value={true}>
                    {t("buttons.yes_btn", {
                      defaultValue: "Yes",
                    })}
                  </Radio>
                  <Radio value={false}>
                    {t("buttons.no_btn", {
                      defaultValue: "No",
                    })}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            )} */}

            {hasFxDeal && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.fundtransfer.fxno", {
                    defaultValue: "Fx Ref Number",
                  })}
                  name={"fxDealRefNo"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.fx_ref_num_require", {
                        defaultValue: "Fx Ref Number is required",
                      }),
                    },
                  ]}
                >
                  <Input
                    onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                    maxLength={30}
                    placeholder={t("pages.fundtransfer.fxno", {
                      defaultValue: "Fx Ref Number",
                    })}
                    size="large"
                    onBlur={(e) => {
                      e.target.value.length > 0 && getConvertedAmount();
                    }}
                  />
                </Form.Item>
              </div>
            )}
            {transferType === "SWIFT" && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("pages.sendMoney.payee.upload_files", {
                    defaultValue: "Upload Files",
                  })}
                  name="file"
                  rules={[
                    {
                      required: true,
                      message: t("pages.sendMoney.payee.upload_files_req", {
                        defaultValue: "Upload Files are required",
                      }),
                    },
                  ]}
                >
                  <Dragger
                    accept="application/pdf"
                    height={100}
                    multiple={false}
                    listType={"picture"}
                    onChange={onChange}
                    onRemove={onRemove}
                    customRequest={handleAction}
                    maxCount={2}
                  >
                    <p className="ant-upload-text" style={{ fontSize: 12 }}>
                      {t("common.click_drag_to_upload", {
                        defaultValue:
                          "Click or drag file to this area to upload",
                      })}
                    </p>
                  </Dragger>
                </Form.Item>
              </div>
            )}

            {transferType === "SWIFT" && modifyVisible && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
                <span className="text-bold">{allFiles.join(", ")}</span>
              </div>
            )}

            {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Form.Item
                label={t("common.remarks", { defaultValue: "Reason" })}
                name={"remarks"}
                rules={[{ required: true, message: "Reason is required" }]}
              >
                <Select
                  placeholder={t("common.remarks", { defaultValue: "Reason" })}
                  bordered={true}
                  size="large"
                  showSearch
                  onChange={(value) => {
                    form.resetFields(["customRemarks"]);
                    setSelectedRemarks(value);
                  }}
                >
                  {remarksList.map((option, idx) => (
                    <Select.Option key={idx} value={option.remarkCode}>
                      {option.remarkDescription}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div> */}
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Form.Item
                name="remarks"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.remark_require", {
                      defaultValue: "Reason is required",
                    }),
                  },
                ]}
                label={t("common.remarks", {
                  defaultValue: "Reason",
                })}
              >
                <Input
                  placeholder={t("common.remarks", {
                    defaultValue: "Reason",
                  })}
                  size="large"
                  onKeyPress={(e) =>
                    allowOnlyAlphaNumericsShouldNotStartWithSpace(e)
                  }
                  maxLength={30}
                />
              </Form.Item>
            </div>
            {selectedRemarks === "Other" && (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label="Custom Remarks"
                  name={"customRemarks"}
                  rules={[
                    { required: true, message: "Custom Reason is required" },
                  ]}
                >
                  <Input
                    onKeyPress={(e) => allowOnlyAlphaNumericsWithSpace(e)}
                    placeholder="Custom Remarks"
                    size="large"
                    maxLength={30}
                  />
                </Form.Item>
              </div>
            )}
            {/* <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-sm-12 col-md-6 col-lg-6"></div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-sm-12 col-md-6 col-lg-6">
              <RemarkTags
                setSelected={setRemarkTag}
                setRemarksTagList={setRemarksTagList}
                remarksTagList={remarksTagList}
              />
            </div> */}
          </div>

          <div className="d-flex justify-content-end  mt-3">
            <Button
              size="large"
              onClick={() => navigate("/send-money")}
              type="default"
              style={{ marginRight: 20 }}
              className="secondary-btn"
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="primary-btn"
            >
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}
            </Button>
          </div>
        </Form>
      </>
    );
  }

  function renderConfirm() {
    return (
      <>
        <h5 className="mb-3">
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>

        <p className="mb-3" style={{ fontSize: 14 }}>
          {t("pages.sendMoney.payee.payment_txt", {
            defaultValue:
              "Please check the payment details carefully, before you proceed",
          })}
        </p>

        <div className="row">
          <div className="bene-align">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <AccountDisplayView />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 text-center">
              <p style={{ fontSize: 10, fontWeight: 600 }}>
                {t("common.to", { defaultValue: "To" })}
              </p>
            </div>
            <div
              className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
              style={{ marginTop: "-8px" }}
            >
              <BeneficiaryDisplay beneDetails={payeeDetails} />
            </div>
          </div>
        </div>

        <div className="mt-3 confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label>
                {t("common.amount", {
                  defaultValue: "Amount",
                })}
              </label>
              <span>
                {amountFormat(formDetails?.amount, formDetails?.txnCcy)}
              </span>
            </div>
            {Object.keys(convertedAmount).length !== 0 && (
              <div className="confirm-label-wrapper">
                <label>
                  {" "}
                  {t("pages.sendMoney.common_sendMoney.deducted_amount", {
                    defaultValue: "Deducted Amount",
                  })}
                </label>
                <span>{convertedAmount.deductedAmt}</span>
              </div>
            )}

            {formDetails?.txnType === "TIPS" && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.pay_bills.mobile_operator_name", {
                    defaultValue: "Mobile Operator Name",
                  })}
                </label>
                <span>{formDetails?.destBankName}</span>
              </div>
            )}
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.payment_history.transfer_type", {
                  defaultValue: "Transfer Type",
                })}
              </label>
              <span>
                {console.log("[[[formDetails?.txnType]]]", formDetails)}
                {formDetails?.txnType === "IAT"
                  ? t("pages.fundtransfer.internal_account_transfer", {
                      defaultValue: "Internal Account Transfer",
                    })
                  : formDetails?.txnType}
              </span>
            </div>
            <div className="confirm-label-wrapper">
              <label>
                {t("pages.view_scheduled_transfer.payment_type", {
                  defaultValue: "Payment Type",
                })}
              </label>
              <span>
                {metaData.paymentTypes[formDetails?.paymentType] ||
                  formDetails?.paymentType}
              </span>
            </div>

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.no_of_instal", {
                    defaultValue: "Number of installment",
                  })}
                </label>
                <span>{formDetails?.numberOfInstallments || "-"}</span>
              </div>
            ) : null}

            {paymentType === "RECURRING" ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.frequency", {
                    defaultValue: "Frequency",
                  })}
                </label>
                <span>{formDetails?.frequency}</span>
              </div>
            ) : null}

            <div className="confirm-label-wrapper">
              <label>
                {t("pages.sendMoney.common_sendMoney.date", {
                  defaultValue: "Date",
                })}
              </label>
              {paymentType === "ONCE" && paymentSubType === "Pay_Now" && (
                <span>{dayjs().format("DD-MM-YYYY")}</span>
              )}
              {paymentType === "ONCE" && paymentSubType === "Pay_Later" && (
                <span>
                  {dayjs(reqDetails?.frequencyDate).format("DD-MM-YYYY")}
                </span>
              )}

              {paymentType === "RECURRING" && (
                <span>
                  {dayjs(formDetails?.scheduledDate).format("DD-MM-YYYY")}
                </span>
              )}
            </div>

            {hasFxDeal ? (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.fundtransfer.fxno", {
                    defaultValue: "Fx Ref Number",
                  })}
                </label>
                <span>{formDetails?.fxDealRefNo}</span>
              </div>
            ) : null}

            {transferType === "SWIFT" && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("pages.sendMoney.payee.uploaded_files", {
                    defaultValue: "Uploaded Files",
                  })}
                </label>
                <span>{allFiles.join(", ")}</span>
              </div>
            )}

              <div className="confirm-label-wrapper">
              <label>
                {t("pages.service_request.common_service.charges", {
                  defaultValue: "Charges",
                })}
              </label>
              <span>{amountFormat(chargesList.charges, formDetails?.txnCcy)}</span>
            </div>
            
            <div className="confirm-label-wrapper">
              <label>
                {t("common.remarks", {
                  defaultValue: "Reason",
                })}
              </label>
              <span>{formDetails?.remarksTag || "-"}</span>
            </div>

            {formDetails?.remarksTag === "Other" && (
              <div className="confirm-label-wrapper">
                <label>
                  {t("common.remarks", {
                    defaultValue: "Reason",
                  })}
                </label>
                <span>{formDetails?.remarks || "-"}</span>
              </div>
            )}
          </div>
        </div>

        <div className="d-flex justify-content-end mt-5 ">
          {/* <Button
            onClick={() => setCancelVisible(true)}
            type="default"
            style={{ marginRight: 30 }}
            className="secondary-btn"
            size="large"
          >
            {t("buttons.cancel_btn", {
              defaultValue: "Cancel",
            })}
          </Button> */}

          <Button
            onClick={() => {
              setStage(1);
              setModifyVisible(true);
            }}
            type="default"
            className="secondary-btn mx-3"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>
          <Button
            onClick={() => fundTransferVerify(formDetails)}
            type="primary"
            className="primary-btn"
            size="large"
          >
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </>
    );
  }

  function renderSuccess() {
    return (
      <div align="center">
        <img height={200} src={successIcon} alt="Success" />

        <h6 className="text-align-center">{respDetails.message}</h6>

        <div className="mt-3 mb-3">
          <Button
            type="primary"
            size="large"
            style={{ width: 120 }}
            onClick={() => navigate("/send-money")}
            className="primary-btn"
          >
            {t("buttons.okay_btn", {
              defaultValue: "Okay",
            })}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Breadcrumb separator=">" className="hide-xs">
        {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/transfer")}>
            {t("navigation.transfer", {
              defaultValue: "Transfers",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {t("navigation.bene_transfer", {
              defaultValue: "Beneficiary Transfer",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {location.state.beneType === "INTERNAL"
                ? t("pages.fundtransfer.internal_bene_transfer", {
                    defaultValue: "Internal Beneficiary Transfer",
                  })
                : location.state.beneType === "OTHERBANK"
                ? t("pages.fundtransfer.other_bene", {
                    defaultValue: "Other Beneficiary Transfer",
                  })
                : location.state.beneType === "INTERNATIONAL"
                ? t("pages.fundtransfer.international_bene", {
                    defaultValue: "International Beneficiary Transfer",
                  })
                : t("pages.fundtransfer.bene_trans", {
                    defaultValue: "Beneficiary Transfer",
                  })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        {stage === 1 ? (
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card">
              {transferType === "TIPS" ? (
                <AccountCard currencyFilter={true} />
              ) : (
                <AccountCard />
              )}
            </Card>
          </div>
        ) : (
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 hide-xs">
            <Card className="application-card">
              <AccountSelectedCard />
            </Card>
          </div>
        )}

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
          <Card className="payee-render-section application-card">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={t("pages.sendMoney.payee.quick_transfer", {
          defaultValue: "Cancel transfer?",
        })}
        open={cancelVisible}
        footer={null}
        width={350}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <p style={{ marginBottom: 30, fontSize: 15 }}>
          {t("pages.otp.quitCancelTitle", {
            defaultValue:
              " If you cancel this transaction now, you will have to start over. Are you sure you want to cancel?",
          })}
        </p>
        <div className="mt-3" align="right">
          <Button
            type="default"
            className="secondary-btn"
            onClick={() => setCancelVisible(false)}
          >
            {t("buttons.no_btn", {
              defaultValue: "No",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setCancelVisible(false);
              navigate("/send-money");
            }}
          >
            {t("buttons.yes_btn", {
              defaultValue: "Yes",
            })}
          </Button>
        </div>
      </Modal>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{respDetails.message}</p>

          <div align="center" className="d-flex justify-content-center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/transfer");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
            {mode === "AA" &&
              paymentType === "ONCE" &&
              paymentSubType === "Pay_Now" && (
                <>
                  <Button
                    size="large"
                    onClick={() => {
                      handleDownload(respDetails);
                    }}
                    className="secondary-btn mx-4"
                  >
                    {t("buttons.download_btn", { defaultValue: "Download" })}
                  </Button>
                </>
              )}
          </div>
        </div>
      </Modal>

      <Modal
        open={isErrorModalVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ width: 380, margin: "0 auto" }} align="center">
          <VscError
            style={{ display: "block", margin: "10px 0" }}
            size={50}
            fill="#ff4d4f"
          />
          <h5 className="mb-3" style={{ color: "#ff4d4f" }}>
            {t("errorMesssages.error", { defaultValue: "Error" })}!
          </h5>
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            {t("pages.sendMoney.payee.file_size_txt", {
              defaultValue: "File size should not be greater than",
            })}{" "}
            {metaData?.internationalFileUploadSize}
          </p>
          <div align="center">
            <Button
              onClick={() => {
                setIsErrorModalVisible(false);
              }}
              type="primary"
            >
              {t("buttons.close_btn", { defaultValue: "Close" })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={isErrorVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <VscError
            style={{ display: "block", margin: "10px 0" }}
            size={50}
            fill="#ff4d4f"
          />
          <h5 className="mb-3" style={{ color: "#ff4d4f" }}>
            Alert!
          </h5>
          <p style={{ marginBottom: 30, fontSize: 15 }}>
            Cross currency transactions are not allowed at this time.
          </p>
          <div align="center">
            <Button
              onClick={() => {
                setIsErrorVisible(false);
              }}
              type="primary"
              size="large"
            >
              {t("buttons.close_btn", { defaultValue: "Close" })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
